import { Box, Stack, Typography } from "@mui/material";
import { DateField, ReferenceField, useRecordContext } from "react-admin";
import { BalanceCard } from "./balanceCard";
import { MyOffers } from "./myOffers";
import { MyOffersCard } from "./myOffersCard";
import { OnlineAssistant } from "./onlineAssistant";
import { Payouts } from "./payouts";
import { PostListCard } from "../post/PostListCard";
import { ORDER_STATUS_VALUE } from "../../config/statuses";
import { PostStatusField } from "../post/PostStatusField";
import LinkInNewWindowField from "../common/linkInNewWindowField";

const PostListFields = [
    <ReferenceField
        label="Order Status"
        source="new_ContentOrderStatus"
        reference="v1_PostsContentStatus"
        link={false}
        key={1}
    >
        <PostStatusField />
    </ReferenceField>,
    <DateField
        source="ordered_on"
        label="Ordered On"
        locales="en-GB"
        key={2}
    />,
    <DateField
        source="new_Contentduedate"
        label="Due Date"
        locales="en-GB"
        key={3}
    />,
    <LinkInNewWindowField
            propertyName="new_TargetURL1"
            label="Target URL"
            showPropertyName={true}
            key={4}
        />,
];

export const SupplierDashboard = () => {
    const { currentUser } = useRecordContext();

    return (
        <Stack pb={8}>
            <Typography variant="h1" my={4}>
                Hi, {currentUser.data.FullName}
            </Typography>
            <Box display="grid" gridTemplateColumns="repeat(18, 1fr)" gap={4}>
                <Box gridColumn="span 13" gridRow="span 3">
                    <PostListCard
                        title="Orders"
                        filterForRole={{
                            supplier_id: currentUser.data.id,
                        }}
                        statusToFilter={[
                            ORDER_STATUS_VALUE.ORDERED,
                            ORDER_STATUS_VALUE.DECLINED,
                        ]}
                        redirectToListButton
                        sort={{ field: "ordered_on", order: "DESC" }}
                        displayOnDashboard
                    >
                        {PostListFields}
                    </PostListCard>
                </Box>
                <Box gridColumn="span 5">
                    <MyOffers />
                </Box>
                <Box gridColumn="span 5">
                    <Payouts />
                </Box>
                <Box gridColumn="span 5">
                    <OnlineAssistant />
                </Box>
                <Box gridColumn="span 9">
                    <MyOffersCard />
                </Box>
                <Box gridColumn="span 9">
                    <BalanceCard />
                </Box>
            </Box>
        </Stack>
    );
};
